import { render, staticRenderFns } from "./GalleryThumb.vue?vue&type=template&id=b140688a&scoped=true&"
import script from "./GalleryThumb.vue?vue&type=script&lang=js&"
export * from "./GalleryThumb.vue?vue&type=script&lang=js&"
import style0 from "./GalleryThumb.vue?vue&type=style&index=0&id=b140688a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b140688a",
  null
  
)

export default component.exports